import React, { FC } from 'react';
import KTileMap from './KTileMap';
import { GameCanvasProps } from '../../components/GameView';

/**
 * Kgsburg game comps: ktilemap
 */
const KoenigsburgGameCanvas: FC<GameCanvasProps> = ({ env, active, game, onSubmit }) => {
  const { clone } = env;

  return <>{clone && <KTileMap active={active} onSubmit={onSubmit} clone={clone} game={game} />}</>;
};

export default KoenigsburgGameCanvas;
